import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router, CanActivate } from '@angular/router';
import { AuthService } from '../auth/auth.service';
import { UserService } from 'src/app/users/services/user.service';
import { UserAdminVerificationStatusEnum } from 'src/app/users/interfaces/user-values';
@Injectable({
   providedIn: 'root'
})
export class LoggedInAuthGuardGuard implements CanActivate {
   constructor(private authService: AuthService,
               private userService: UserService,
               private router: Router) { }

   canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
      return new Promise((resolve, reject) => {
         if (!this.authService.isAuthenticated() || !this.authService.isMailVerified()) {
            resolve(true);
         } else {
            this.userService.getUserAdminVerificationStatus().then((status) => {
               if (status === UserAdminVerificationStatusEnum.PENDING) {
                  resolve(true);
               } else {
                  this.router.navigate(['/lectures']);
                  resolve(true);
               }
            });
         }
      });
   }
}

